import React from 'react'
import './Services.css'
import { FaCheck } from 'react-icons/fa'

const Services = () => {
    return (
        <section id="services">

            <h2><b>What I Do</b></h2>

            <div className="container services__container">
                <article className="service">
                    <div className="service__head">
                        <h3>Help Desk Support</h3>
                    </div>
                    <ul className="service__list">

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Computer/Laptop/Printer Hardware Troublshooting</p>
                        </li>

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Software Installation and Configuration</p>
                        </li>

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Providing technical support to end-users via phone, email, or in person</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Assisting users remotely with troubleshooting and software installations.</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Desktop/Laptop Assembly and Setup</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>OS Installation (Windows and Linux)</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Upgrading hardware components (RAM, hard drives, etc.)</p>
                        </li>
                    </ul>
                </article>



                <article className="service">
                    <div className="service__head">
                        <h3>System Administration</h3>
                    </div>
                    <ul className="service__list">

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Ubuntu Server administration, including installation, configuration,
                                and maintenance</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Package management using apt and dpkg commands</p>
                        </li>

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Installing and managing databases such as MySQL on Ubuntu
                                Server</p>
                        </li>

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Setting up and managing web servers like Apache HTTP Server on
                                Ubuntu.</p>
                        </li>

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Monitoring system performance using tools like Nagios</p>
                        </li>

                    </ul>
                </article>



                <article className="service">
                    <div className="service__head">
                        <h3>Network Administration</h3>
                    </div>
                    <ul className="service__list">

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Network troubleshooting (TCP/IP, DNS, DHCP).</p>
                        </li>

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Configuring network interfaces, firewall rules, and VPN connections</p>
                        </li>

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Monitoring and Documenting Firewall logs and Netwrok Traffic</p>
                        </li>

                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Managing and Configuring Network Switch, Access Point</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon' />
                            <p>Managing, Monitorting and Configuring Network Devices usingg Omada Controller </p>
                        </li>
                    </ul>
                </article>


            </div>
        </section>

    )
}

export default Services